"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertInline = void 0;
const malty_atoms_icon_1 = require("@carlsberggroup/malty.atoms.icon");
const malty_atoms_link_1 = require("@carlsberggroup/malty.atoms.link");
const malty_atoms_text_1 = require("@carlsberggroup/malty.atoms.text");
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const AlertInline_styled_1 = require("./AlertInline.styled");
const AlertInline_types_1 = require("./AlertInline.types");
function AlertInline({ icon, size = AlertInline_types_1.AlertInlineSize.Default, color = AlertInline_types_1.AlertInlineColor.Notification, dataQaId, firstAction, firstActionText, secondAction, secondActionText, message, title }) {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    const labelFontColor = color === AlertInline_types_1.AlertInlineColor.Notification || color === AlertInline_types_1.AlertInlineColor.Fail
        ? malty_atoms_text_1.TextColor.White
        : malty_atoms_text_1.TextColor.DigitalBlack;
    const alertIconColor = color === AlertInline_types_1.AlertInlineColor.Notification || color === AlertInline_types_1.AlertInlineColor.Fail
        ? malty_atoms_icon_1.IconColor.White
        : malty_atoms_icon_1.IconColor.DigitalBlack;
    const actionButtonColor = color === AlertInline_types_1.AlertInlineColor.Notification || color === AlertInline_types_1.AlertInlineColor.Fail;
    const onFirstAction = () => {
        if (firstAction) {
            firstAction();
        }
    };
    const onSecondAction = () => {
        if (secondAction) {
            secondAction();
        }
    };
    const renderIcon = () => (react_1.default.createElement(malty_atoms_icon_1.Icon, { className: "inline-alert-icon", name: icon, size: malty_atoms_icon_1.IconSize.Small, color: alertIconColor, "data-testid": `${dataQaId}-icon` }));
    const renderLabel = () => (react_1.default.createElement(AlertInline_styled_1.StyledTextContainer, { "data-alert-label-container": true },
        react_1.default.createElement(malty_atoms_text_1.Text, { color: labelFontColor, textStyle: size === AlertInline_types_1.AlertInlineSize.Default ? malty_atoms_text_1.TextStyle.MediumSmallDefault : malty_atoms_text_1.TextStyle.SmallDefault }, message)));
    const renderActions = () => (react_1.default.createElement(AlertInline_styled_1.StyledActionContainer, { theme: theme, "data-testid": `${dataQaId}-action-container` },
        react_1.default.createElement(AlertInline_styled_1.StyledActionItem, { theme: theme },
            react_1.default.createElement(malty_atoms_link_1.Link, { color: actionButtonColor ? malty_atoms_link_1.LinkColor.White : malty_atoms_link_1.LinkColor.DigitalBlack, linkStyle: malty_atoms_link_1.LinkStyle.MediumSmallBold, onClick: onFirstAction, dataTestId: `${dataQaId}-first-action` }, firstActionText)),
        react_1.default.createElement(AlertInline_styled_1.StyledActionItem, { theme: theme },
            react_1.default.createElement(malty_atoms_link_1.Link, { color: actionButtonColor ? malty_atoms_link_1.LinkColor.White : malty_atoms_link_1.LinkColor.DigitalBlack, linkStyle: malty_atoms_link_1.LinkStyle.MediumSmallBold, onClick: onSecondAction, dataTestId: `${dataQaId}-second-action` }, secondActionText))));
    return (react_1.default.createElement(AlertInline_styled_1.StyledAlertInLineWrapper, { theme: theme },
        react_1.default.createElement(AlertInline_styled_1.StyledAlertInLine, { hasTitle: !!title, hasActions: !!firstActionText || !!secondActionText, hasIcon: !!icon, size: size, "data-testid": `${dataQaId}-alert-container`, color: color, theme: theme },
            title && (react_1.default.createElement(AlertInline_styled_1.StyledTitle, { theme: theme },
                react_1.default.createElement(malty_atoms_text_1.Text, { textStyle: malty_atoms_text_1.TextStyle.MediumSmallBold, color: labelFontColor }, title))),
            react_1.default.createElement(AlertInline_styled_1.StyledContent, { theme: theme, "data-testid": `${dataQaId}-alert-content` },
                !title && !firstActionText && !secondActionText && icon && renderIcon(),
                renderLabel()),
            (firstActionText || secondActionText) && renderActions())));
}
exports.AlertInline = AlertInline;
//# sourceMappingURL=AlertInline.js.map